var map = {
	"./admin.vue": [
		"b49f",
		"chunk-1edf9bbd"
	],
	"./menu.vue": [
		"ed44",
		"chunk-4a6b80dc"
	],
	"./role.vue": [
		"c205",
		"chunk-7450edb4"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "c50c";
module.exports = webpackAsyncContext;